import React from 'react';
import { Text } from '..';
import *  as S from './styles'

export default function ErrorMessage({ inset, children}) {
    return <S.MessageHolder>
        <Text level="3" inset={inset}>{children}</Text>
    </S.MessageHolder>
}